
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ReplyType } from 'enums/ReplyType';
import { QuestionCategoryType } from 'enums/QuestionCategoryType';
import { QuestionReplyOptionModel } from './Entities.GormCrm.QuestionReplyOption';
import { QuestionTagModel } from './Entities.GormCrm.QuestionTag';
import { QuestionnaireQuestionProductModel } from './Entities.GormCrm.QuestionnaireQuestionProduct';
import { QuestionnaireQuestionReplyModel } from './Entities.GormCrm.QuestionnaireQuestionReply';
import { QuestionnaireQuestionModel } from './Entities.GormCrm.QuestionnaireQuestion';
import { Model, ModelProperty } from 'models/Model';


export class QuestionModel extends Model<QuestionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'questionReplyInputType', type: 'ReplyType' },
		{ name: 'category', type: 'QuestionCategoryType' },
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'active', type: 'boolean' },
		{ name: 'questionText', type: 'string' },
		{ name: 'requiredNumberOfReplies', type: 'number' },
		{ name: 'questionReplyOptions', type: 'QuestionReplyOptionModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionReplyOptionModel }, properties: () => { return QuestionReplyOptionModel.classProperties } },
		{ name: 'questionTags', type: 'QuestionTagModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionTagModel }, properties: () => { return QuestionTagModel.classProperties } },
		{ name: 'questionnaireQuestionProducts', type: 'QuestionnaireQuestionProductModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionProductModel }, properties: () => { return QuestionnaireQuestionProductModel.classProperties } },
		{ name: 'questionnaireQuestionReplies', type: 'QuestionnaireQuestionReplyModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionReplyModel }, properties: () => { return QuestionnaireQuestionReplyModel.classProperties } },
		{ name: 'questionnaireQuestions', type: 'QuestionnaireQuestionModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionModel }, properties: () => { return QuestionnaireQuestionModel.classProperties } }
	];
	[key: string]: any;
	
	public questionReplyInputType: ReplyType;
	public category?: QuestionCategoryType;
	public id?: string;
	public created?: Date;
	public deleted?: Date;
	public active: boolean;
	public questionText: string;
	public requiredNumberOfReplies?: number;
	public questionReplyOptions: QuestionReplyOptionModel[];
	public questionTags: QuestionTagModel[];
	public questionnaireQuestionProducts: QuestionnaireQuestionProductModel[];
	public questionnaireQuestionReplies: QuestionnaireQuestionReplyModel[];
	public questionnaireQuestions: QuestionnaireQuestionModel[];
    
	constructor(){
		super();
		this.questionReplyInputType = 0;
		this.category = undefined;
		this.id = undefined;
		this.created = undefined;
		this.deleted = undefined;
		this.active = false;
		this.questionText = '';
		this.requiredNumberOfReplies = undefined;
		this.questionReplyOptions = [];
		this.questionTags = [];
		this.questionnaireQuestionProducts = [];
		this.questionnaireQuestionReplies = [];
		this.questionnaireQuestions = [];
		
	}
	getProperties(){
		return QuestionModel.classProperties;
	}
}

